module.exports = __webpack_public_path__ + "img/playstore.8a9b3f4f.png";